import { db, storage} from "../../firebase/firebase";
import revealData from '../../util/revealData';
import _ from 'lodash';
import {getAffiliatesRequest} from './Affiliates';
import { getOrdersLength } from "./Orders";
import {getProductsRequest} from './Products'

const getAllMajoristsRequest = async (affiliationRequests, affiliates) => {
  try {
    let raw = [];
    let b = [...affiliationRequests.map(ar => ar.targetId), ...affiliates.map(a => a.targetId)];
    await db.ref('users/').orderByChild('rol').equalTo('major').once('value', async data => {
      const majorists = await Object.values(data.val());
      await majorists.forEach( majorist => { if(!b.includes(majorist.id)) raw.push(majorist)})
    }); 
    return await revealData(raw);
  } catch (error) {
    return error
  }
}

const getAllClientsRequest = async (affiliationRequests, affiliates) => {
  try {
    let raw = [];
    let b = [...affiliationRequests.map(ar => ar.targetId), ...affiliates.map(a => a.targetId)];
    await db.ref('users/').orderByChild('rol').equalTo('client').once('value', async data => {
      const clients = await Object.values(data.val());
      await clients.forEach( client => { if(!b.includes(client.id)) raw.push(client) })
    }); 
    return await revealData(raw);
  } catch (error) {
    return error
  }
}

const getDashboardRequest = async (userId, userRole, orders, invoices, waiting, cancelled) => {
  try {
    let dashboard;
    let user;
    const affiliates = await getAffiliatesRequest(userId)
    if(userRole === 'client') {
      await db.ref(`users/${userId}`).once('value', async userSnap => {
        user = await userSnap.val();
      })
      dashboard = await {
        orders: orders.length,
        invoices: invoices.length,
        consultedProducts: user.consultedProducts,
        expenses: user.expenses,
        affiliates,
      }
    } else {
      let products = await getProductsRequest(userId)
      await db.ref(`users/${userId}`).once('value', async userSnap => {
        user = await userSnap.val();
      })
      dashboard = await {
        cancelledOrders: cancelled.length,
        waitingOrders: waiting.length,
        products: products.length,
        approvedOrders: invoices.length,
        affiliates,
        growth: user.growth,
        revenue: user.revenue,
      }
    }
    return dashboard;
  } catch (error) {
    return error
  }
}

const editUserRequest = async ({shouldUpdateImage, ...user}) => {
  try {
    let imageSrc = user.image;
    if(shouldUpdateImage) {
      const uploadTask = 
        await storage
              .ref()
              .child(`users/${user.id}`)
              .putString(user.image, 'data_url')
      imageSrc = await uploadTask.ref.getDownloadURL();
  }

    await db.ref(`users/${user.id}`).update({
      ...user,
      image: imageSrc,
    });
  } catch (error) {
    console.log(error)
  }
}

const getUsersRequest = async (userType) => {
  let users = []
  if(userType === 'majorists') {
    await db.ref('users/').orderByChild('rol').equalTo('major').once('value', async data => {
      users = await data.val() ? Object.values(data.val()) : []
    })
  } else {
    await db.ref('users/').orderByChild('rol').equalTo('client').once('value', async data => {
      users = await data.val() ? Object.values(data.val()) : []
    })
  }
  return await users
}

const getAllProductsRequest = async () => {
  let products = []
    await db.ref('products/').once('value', async data => {
      products = await data.val() ? Object.values(data.val()) : []
    })

  return await products
}

export {
  getAllClientsRequest,
  getAllMajoristsRequest,
  getDashboardRequest,
  editUserRequest,
  getUsersRequest,
  getAllProductsRequest
}